import { render } from "./topBar.vue?vue&type=template&id=6af8b81c"
import script from "./topBar.vue?vue&type=script&lang=js"
export * from "./topBar.vue?vue&type=script&lang=js"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__